import { ApiError } from "@/api/client";

/**
 * How many undelivered records made the engine refuse a delete or a reset, or
 * `undefined` when the failure was something else. The engine refuses with a
 * conflict that names the count; an operation that discards them has to say so.
 */
export function undeliveredRecords(err: unknown): number | undefined {
  if (!(err instanceof ApiError) || err.status !== 409) return undefined;
  const match = /still has (\d+) undelivered records/.exec(err.message);
  return match ? Number(match[1]) : undefined;
}

/**
 * What going ahead discards, said before the second confirmation. `subject`
 * opens the sentence and `action` names what discards the records
 * ("Deleting it", "Resetting").
 */
export function UndeliveredNotice({
  subject,
  action,
  records,
}: {
  subject: React.ReactNode;
  action: string;
  records: number;
}) {
  return (
    <>
      {subject} still holds{" "}
      <strong>
        {records.toLocaleString("en-US")} undelivered{" "}
        {records === 1 ? "record" : "records"}
      </strong>
      . {action} discards them: they are not delivered, and the source may not
      be able to read them again. To keep them, cancel, start the pipeline and
      let it drain first.
    </>
  );
}
